'use client';

import { type SliceCreator, type EditorStore, type EditorMediaSlice } from './type';

export const createEditorMediaSlice: SliceCreator<
    EditorMediaSlice,
    EditorStore
> = () => ({
    uploadingMedia: {},
    isCarouselUploading: false,
});
